import { render, staticRenderFns } from "./SearchPopover.vue?vue&type=template&id=6e84951b&"
import script from "./SearchPopover.vue?vue&type=script&lang=js&"
export * from "./SearchPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports